import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const MissingText = styled.div`
  color: light-dark(${globals.gray600}, var(--moon-350));
  margin-bottom: 16px;
`;

export const Prompt = styled.div``;

export const PromptHeader = styled.h2`
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 8px;
`;

export const PromptBody = styled.div`
  line-height: 20px;
`;

export const PromptButtonContainer = styled.div`
  margin: 24px 0;
`;

export const PromptHint = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
`;

export const PromptHintIcon = styled(Icon)`
  font-size: 20px;
  margin-right: 3px;
`;

export const PromptHintBody = styled.div``;

export const Container = styled.div`
  background-color: light-dark(${globals.gray200}, var(--moon-850));
  border-radius: 3px;
  max-width: 920px;
  @media (max-width: ${globals.MOBILE_WIDTH}px) {
    display: flex;
    flex-direction: column;
    padding: 20px;
    ${Prompt} {
      margin-top: 32px;
    }
    i {
      transform: rotate(90deg);
    }
  }
  @media (min-width: ${globals.MOBILE_WIDTH}px) {
    column-gap: 40px;
    display: grid;
    grid-template-columns: 224px 1fr;
    padding: 32px;
  }
`;

export const CardDescription = styled.div`
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  width: 100%;
  color: ${globals.THEME.textTertiary};
  font-family: 'Source Sans 3';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  align-items: center;
`;

export const TooltipHeader = styled.h3`
  color: light-dark(${globals.white}, var(--moon-900));
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const TooltipBody = styled.div`
  color: light-dark(${globals.gray300}, var(--moon-600));
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 16px;
`;
